import z, { ZodType } from 'zod';
import { Device } from './device';
import { Player, playerSchema } from './player';

export type ActivateDeviceResponse = {
	players: Player[];
	device: Omit<Device, 'players'>;
};

export const activateDeviceResponseSchema: ZodType<ActivateDeviceResponse> = z.object({
	players: z.array(playerSchema),
	device: z.object({
		id: z.number(),
		name: z.string(),
		externalDeviceId: z.string(),
		cashdeskCode: z.string(),
		isActive: z.boolean(),
	}),
});
